export default [
    {label: 'Female', value: 'FEMALE'},
    {label: 'Male', value: 'MALE'}
]
